module.exports = __webpack_public_path__ + "img/illustration-login2-blue3.1ad170b1.svg";